import { colors, Tooltip } from '@material-ui/core';
import { Tags, TagsFill } from 'react-bootstrap-icons';
import { numberFormatCurrency } from '../../utils/helper';

export const mdExpensesReportColumn = [
  {
    field: 'transaction_date',
    headerName: 'Date',
    width: 150,
    sortable: false,
  },
  {
    field: 'md_code',
    headerName: 'MD Code',
    width: 150,
    sortable: false,
  },
  {
    field: 'reference',
    headerName: 'Reference',
    width: 150,
    sortable: false,
  },
  {
    field: 'amount',
    headerName: 'Amount',
    width: 150,
    type: 'number',
  },
  {
    field: 'cost_center_code',
    headerName: 'Cost Center Code',
    width: 150,
    sortable: false,
  },
  {
    field: 'cost_center_name',
    headerName: 'Cost Center Name',
    width: 150,
    sortable: false,
  },
  {
    field: 'account_code',
    headerName: 'Account Code',
    width: 150,
    sortable: false,
  },
  {
    field: 'account_name',
    headerName: 'Account Name',
    width: 250,
    sortable: false,
  },
  {
    field: 'program_code',
    headerName: 'Program Code',
    width: 250,
    sortable: false,
  },
  {
    field: 'program_name',
    headerName: 'Program Name',
    width: 250,
    sortable: false,
  },
  {
    field: 'particulars',
    headerName: 'Particular',
    width: 250,
    sortable: false,
  },
  {
    field: 'remarks',
    headerName: 'Remarks',
    width: 250,
    sortable: false,
  },
  {
    field: 'details',
    headerName: 'Details',
    width: 250,
    sortable: false,
  },
];
